import components from './components';
import blocks from './blocks';
import listeners from './listeners';

export default (editor, config) => {
  blocks(editor, config);
  components(editor, config);
  listeners(editor, config);
};
